import { ProductTypeEnum } from '../model/enums/product-capture.enums';
import { ProductCaptureData } from '../model/interfaces/product-capture.interface';

export class ProductUtils {
  static isFxPair(productType: ProductTypeEnum) {
    const FX_PAIR_PRODUCTS = [
      ProductTypeEnum.CHOOSER,
      ProductTypeEnum.DUAL_CURRENCY_NOTE,
      ProductTypeEnum.PRDC,
      ProductTypeEnum.FX_DIGITAL_COUPON_NOTE,
    ];
    return FX_PAIR_PRODUCTS.includes(productType);
  }

  static isBond(productType: ProductTypeEnum) {
    const BOND_PRODUCTS = [ProductTypeEnum.REVERSE_CONVERTIBLE_BOND];
    return BOND_PRODUCTS.includes(productType);
  }

  static allowMultipleAssets(productType: ProductTypeEnum) {
    const SINGLE_ASSET_PRODUCTS = [
      ProductTypeEnum.DUAL_CURRENCY_NOTE,
      ProductTypeEnum.DROP_BACK_CERTIFICATE,
      ProductTypeEnum.FX_DIGITAL_COUPON_NOTE,
      ProductTypeEnum.PRDC,
    ];

    return !SINGLE_ASSET_PRODUCTS.includes(productType);
  }

  static processData(data: any): {
    composeProduct: (...functions: Function[]) => ProductCaptureData;
  } {
    function composeProduct(...functions: Function[]): ProductCaptureData {
      return functions.reduce((acc, fn) => fn(acc), data);
    }

    return {
      composeProduct,
    };
  }
}
